import pdfIcon from '../assets/icon/mimetype/pdf.svg'
import aacIcon from '../assets/icon/mimetype/aac.svg'
import pngIcon from '../assets/icon/mimetype/png.svg'
import aviIcon from '../assets/icon/mimetype/avi.svg'
import cssIcon from '../assets/icon/mimetype/css.svg'
import csvIcon from '../assets/icon/mimetype/csv.svg'
import docIcon from '../assets/icon/mimetype/msword.svg'
import gifIcon from '../assets/icon/mimetype/gif.svg'
import htmlIcon from '../assets/icon/mimetype/html.svg'
import jpegIcon from '../assets/icon/mimetype/jpeg.svg'
import jsIcon from '../assets/icon/mimetype/javascript.svg'
import jsonIcon from '../assets/icon/mimetype/json.svg'
import mp3Icon from '../assets/icon/mimetype/mp3.svg';
import mp4Icon from '../assets/icon/mimetype/mp4.svg';
import mpegIcon from '../assets/icon/mimetype/mpeg.svg';
import odpIcon from '../assets/icon/mimetype/vnd-oasis-opendocument-presentation.svg';
import odsIcon from '../assets/icon/mimetype/vnd-oasis-opendocument-spreadsheet.svg';
import odtIcon from '../assets/icon/mimetype/vnd-oasis-opendocument-text.svg';
import pptIcon from '../assets/icon/mimetype/vnd-ms-powerpoint.svg'
import rtfIcon from '../assets/icon/mimetype/richtext.svg'
import svgIcon from '../assets/icon/mimetype/svg-xml.svg'
import txtIcon from '../assets/icon/mimetype/plain.svg'
import wavIcon from '../assets/icon/mimetype/vnd-wave.svg'
import xlsIcon from '../assets/icon/mimetype/vnd-ms-excel.svg'
import xmlIcon from '../assets/icon/mimetype/xml.svg'
import noIconFile from '../assets/icon/mimetype/file.svg'
import aidata from '../assets/icon/mimetype/custom-aidata.svg'
import aipackage from '../assets/icon/mimetype/custom-aipackage.svg'
import aimacro from '../assets/icon/mimetype/custom-aimacro.svg'
import aisource from '../assets/icon/mimetype/custom-aisource.svg'
import keynote from '../assets/icon/mimetype/x-iwork-keynote-sffkey.svg'
import pages from '../assets/icon/mimetype/pages.svg'
import numbers from '../assets/icon/mimetype/numbers.svg'

function iconMapping(icon) {
    switch (icon) {
        //pdf
        case 'application/pdf':
            return pdfIcon;
        //aac
        case 'audio/aac':
            return aacIcon;
        //image
        case 'image/apng':
        case 'image/png':
            return pngIcon;
        //video
        case 'video/x-msvideo':
            return aviIcon;

        //css
        case 'text/css':
            return cssIcon;
        //csv
        case 'text/csv':
            return csvIcon;

        //doc
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return docIcon;

        //gif
        case 'image/gif':
            return gifIcon;

        //html
        case 'text/html':
            return htmlIcon;

        //jpeg
        case 'image/jpeg':
            return jpegIcon;

        //js
        case 'text/javascript':
            return jsIcon;

        //json
        case 'application/json':
        case 'application/ld+json':
            return jsonIcon;

        //mp3
        case 'audio/mpeg':
            return mp3Icon;

        //mp4
        case 'video/mp4':
            return mp4Icon;
        //mpeg
        case 'video/mpeg':
            return mpegIcon;

        //odp
        case 'application/vnd.oasis.opendocument.presentation':
            return odpIcon;

        //ods
        case 'application/vnd.oasis.opendocument.spreadsheet':
            return odsIcon;
        //odt
        case 'application/vnd.oasis.opendocument.text':
            return odtIcon;

        //php
        // case 'application/x-httpd-php':
        //     return phpIcon;

        //ppt
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return pptIcon;

        //rtf
        case 'application/rtf':
            return rtfIcon;

        //svg
        case '	image/svg+xml':
            return svgIcon;

        //text
        case 'text/plain':
            return txtIcon;

        //wav
        case 'audio/wav':
            return wavIcon;

        //xls
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return xlsIcon;

        //xml
        case 'application/xml ':
            return xmlIcon;

        case "aiplan/data":
            return aidata;
        case "aiplan/package":
            return aipackage;
        case "aiplan/macro":
            return aimacro;
        case "aiplan/datasource":
            return aisource;
        case "application/x-iwork-keynote-sffkey":
            return keynote;
        case "application/x-iwork-pages-sffpages":
            return pages;
        case "application/x-iwork-numbers-sffnumbers":
            return numbers;
        default:
            return noIconFile;
    }
}

export { iconMapping }